import ContentFilter from "@material-ui/icons/FilterList";
import React from "react";
import {
    SelectInput,
    AutocompleteInput,
    ReferenceInput,
    TextInput
} from 'react-admin';
import { Form } from "react-final-form";
import { Box, Button } from "@material-ui/core";
import ContractSelectInput from "../component/ContractSelectInput";
import MedicalPrograms from "../helper/MedicalPrograms";

const FilterButton = ({ showFilter }) => (
    <Button
        size="small"
        color="primary"
        onClick={() => showFilter("main")}
        startIcon={<ContentFilter />}
    >
        Фільтр
    </Button>
);

const FilterForm = ({
                        displayedFilters,
                        filterValues,
                        setFilters,
                        hideFilter,
                        open
                    }) => {
    if (!displayedFilters.main) {
        return null;
    }

    const onSubmit = values => {
        if (Object.keys(values).length > 0) {
            setFilters(values);
        } else {
            hideFilter("main");
        }
    };

    const resetFilter = () => {
        setFilters({}, []);
    };

    const filterToQuery = searchText => ({ name: `%${searchText}%` });
    const contractNumber = contract => contract.contractNumber;

    return (
        <div>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Box mt={2} />
                        <Box display="flex" alignItems="flex-end" mb={1}>
                            <Box component="span" mr={2} style={{width: '300px;'}}>
                                <ContractSelectInput
                                    label="Номер контракту"
                                    source="contract_number"
                                    allowEmpty={true}
                                    optionText="contractNumber"
                                    optionValue="contractNumber"
                                />
                                {/*<ReferenceInput label="Номер контракту" source="contract_number" reference="contracts">*/}
                                {/*    <SelectInput optionText="contractNumber" optionValue="contractNumber" resettable={true} />*/}
                                {/*</ReferenceInput>*/}
                            </Box>
                            <Box component="span" mr={2}>
                                <SelectInput label="Мед. програма" source="medical_program_id" allowEmpty={true} choices={MedicalPrograms} />
                            </Box>
                            <Box component="span" mr={2} style={{width: '300px;'}}>
                                <ReferenceInput label="Аптека" source="division_id" reference="divisions" perPage={300}>
                                    <AutocompleteInput resettable={true} />
                                </ReferenceInput>
                            </Box>
                            <Box component="span" mr={2}>
                                <SelectInput label="Статус" source="is_active" allowEmpty={true} choices={[
                                    {id: "true", name: 'АКТИВНА'},
                                    {id: "false", name: 'НЕ АКТИВНА'},
                                ]} />
                            </Box>
                            <Box component="span" mr={2} mb={3.6}>
                                <Button variant="outlined" color="primary" type="submit">
                                    Показати
                                </Button>
                            </Box>
                            <Box component="span" mb={3.6}>
                                <Button variant="outlined" onClick={resetFilter}>
                                    Закрити
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            </Form>
        </div>
    );
};

const Filter = props => {
    return props.context === "button" ? (
        <FilterButton {...props} />
    ) : (
        <FilterForm {...props} />
    )
};

export default Filter;